import React, { Component, Fragment } from 'react';
import { Modal, Button } from 'react-bootstrap';

class Example extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
  }
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  render() {
    const { data } = this.props;
    const { functionClose } = this.props;
    ////console.log(data);
    return (
      <Fragment>
        <Button size="sm" onClick={this.handleShow} variant="outline-primary">Cerrar</Button>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>CONFIRMACION DE CIERRE</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Esta seguro que desea cerrar el turno del vendedor {data.NOMBRE_VENDEDOR}?
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose} variant="secondary">Cancelar</Button>
            <Button onClick={()=> { functionClose (data.ID_TURNOS) } } variant="primary">Confirmar</Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;